import { render, staticRenderFns } from "./settlementXMYTab.vue?vue&type=template&id=ffbce526&scoped=true"
import script from "./settlementXMYTab.vue?vue&type=script&lang=js"
export * from "./settlementXMYTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbce526",
  null
  
)

export default component.exports